<script lang="ts" setup>
import MunicipalityForm from '@/components/municipalities/MunicipalityForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import {
  MunicipalitiesActions,
  MunicipalityStoreState,
} from '@/stores/municipalities.store';
import { Municipality } from '@/models/municipality.model';

const store = useStore<ShiftCMSState & { ms: MunicipalityStoreState }>();
const dataTables = computed<Municipality[]>(
  () => store.state.ms.municipalities,
);

const update = () => {
  store.dispatch(MunicipalitiesActions.GetMunicipalities);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const editMunicipality = (_: Event, { item }: { item: Municipality }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(MunicipalityForm),
    data: item,
  });
};

const addMunicipality = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(MunicipalityForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '50%' },
  { title: 'Postal codes', key: 'postalCodes', width: '25%' },
  { title: 'On Site', key: 'impactRelevant', width: '10%' },
  { title: 'Date', key: 'creationDate', width: '10%' },
];
</script>

<template>
  <v-container>
    <h2>Municipalities</h2>

    <v-data-table
      density="compact"
      @click:row="editMunicipality"
      :headers="headers"
      :items="dataTables"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.creationDate="{ value }">
        {{ format(value, 'do MMMM yyyy - HH:mm') }}
      </template>
      <template v-slot:item.postalCodes="{ value }">
        {{ [...value].splice(0, 5).join(', ')
        }}{{ value.length > 5 ? '...' : '' }}
      </template>
      <template v-slot:item.impactRelevant="{ value }">
        <v-icon icon="mdi-check" v-if="value" />
        <v-icon icon="mdi-circle-off-outline" v-if="!value" />
      </template>
    </v-data-table>

    <v-btn @click="addMunicipality" color="success">Add Municipality</v-btn>
  </v-container>
</template>
